import type { HTMLAttributes } from 'react'
import { cn } from '~/lib/utils'

/** 상태 색 의미는 두 표면(엔드유저/어드민)에서 동일하게 쓴다. */
export type BadgeTone =
    | 'primary'
    | 'accent'
    | 'success'
    | 'warning'
    | 'danger'
    | 'point'
    | 'info'
    | 'neutral'
    | 'gray'

export type BadgeSize = 'default' | 'large'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
    tone?: BadgeTone
    size?: BadgeSize
}

// 미니멀 상태 배지 — subtle 표면 + 의미색 텍스트. 시맨틱 토큰만 사용.
const TONE_CLASSES: Record<BadgeTone, string> = {
    primary: 'bg-accent text-accent-foreground border-transparent',
    accent: 'bg-accent text-accent-foreground border-transparent',
    success: 'bg-success-subtle text-success border-transparent',
    warning: 'bg-warning-subtle text-warning border-transparent',
    danger: 'bg-destructive/10 text-destructive border-transparent',
    point: 'bg-point-subtle text-point border-transparent',
    info: 'bg-info-subtle text-info border-transparent',
    neutral: 'bg-secondary text-secondary-foreground border-transparent',
    gray: 'bg-secondary text-secondary-foreground border-transparent',
}

/** 미니멀 상태 배지. */
export function Badge({
    className,
    tone = 'neutral',
    size: _size = 'default',
    ...props
}: BadgeProps) {
    return (
        <span
            data-slot='badge'
            className={cn(
                'inline-flex h-5 items-center gap-1 rounded-[var(--radius-sm)] border px-1.5 text-[11px] font-semibold tracking-wide whitespace-nowrap',
                TONE_CLASSES[tone],
                className
            )}
            {...props}
        />
    )
}
